// extracted by mini-css-extract-plugin
export var comment = "style-module--comment--9e169";